module.exports = __webpack_public_path__ + "img/w矩形 78@3x.d44fa04a.png";